/* eslint-disable react-hooks/exhaustive-deps */
import { Link } from 'react-router-dom';
import { RiArrowLeftSLine } from 'react-icons/ri';

import { useContext, useEffect, useMemo, useRef, useState } from 'react';
import CustomSelect from 'components/custom-select';
import { AuthContext } from 'context/AuthContext';
import { getPlayerInfo } from 'services/dashboard.service';
import { getMissaoEquipePrefixo } from 'services/achievement.service';
import { PointItem } from 'components/point-item';
import ArticlePlaceholder from 'components/ui/article-placeholder';
import ReactPaginate from 'react-paginate';
import { IoIosArrowBack, IoIosArrowForward } from 'react-icons/io';
import { RedePoint } from 'pages/Rede/components/point';
import ReactInputMask from 'react-input-mask';
import { TbSearch } from 'react-icons/tb';

const options: any = [
  { value: '', label: 'Todos' },
  { value: 300, label: '300 pontos' },
  { value: 600, label: '600 pontos' },
  { value: 700, label: '700 pontos' },
  { value: 1200, label: '1200 pontos' },
  { value: 1300, label: '1300 pontos' },
  { value: 1500, label: '1500 pontos' },
  { value: 2500, label: '2500 pontos' },
  { value: 5000, label: '5000 pontos' },
];

interface Props {
  onClose: () => void;
}
export default function Detail({ onClose }: Props) {
  const { user, realCycle, currentCycle } = useContext(AuthContext);

  const [mask] = useState('');
  const searchRef = useRef<any>();

  const [optionsCycle, setOptionsCycle] = useState<any>([]);
  const [activeCicle, setActiveCicle] = useState<any>(null);
  const [activeFase, setActiveFase] = useState<any>(null);

  const [load, setLoad] = useState(false);
  const [missionList, setMissionList] = useState<any>([]);
  const [page, setPage] = useState(0);
  const [activePag, setActivePag] = useState(0);
  const [pontos, setPontos] = useState('');

  const [total, setTotal] = useState(0);

  useEffect(() => {
    if (!realCycle) return;

    const cycleOptions = realCycle.map((cycle: any) => {
      cycle.label = 'Ciclo ' + cycle.title;
      cycle.value = cycle._id;

      cycle.steps.map((step: any) => {
        step.label = 'Fase ' + step.title;
        step.value = step._id;

        return step;
      });

      return cycle;
    });

    setOptionsCycle(cycleOptions);

    if (!activeCicle) {
      setActiveCicle(cycleOptions[0].value);
      setPontos('');
    }
  }, [realCycle]);

  async function loadData(itemPage?: number, e?: any) {
    e?.preventDefault();

    if (user?._id) {
      setLoad(true);
      const res = await getPlayerInfo(user._id);

      const rangeItem = itemPage ? itemPage * 20 : 0;

      setActivePag(itemPage ? itemPage : 0);
      setMissionList([]);

      const data = await getMissaoEquipePrefixo(
        res.prefixo,
        currentCycle?.date_start,
        currentCycle?.date_finish,
        activeCicle,
        activeFase,
        searchRef.current.value,
        rangeItem,
        pontos ? pontos : null,
      );
      setPage(data.range.pages);

      setTotal(data.range.total);

      setMissionList(data.result);
      setLoad(false);
    }
  }

  useEffect(() => {
    if (!user?._id || !currentCycle) return;
    loadData();
  }, [user, currentCycle, activeCicle, pontos, activeFase]);

  function getIndexByValue(array: any, value: string) {
    return array.findIndex((element: any) => element.value === value);
  }

  const activeCycleObj = useMemo(() => optionsCycle[getIndexByValue(optionsCycle, activeCicle)], [activeCicle]);

  const activeFaseObj = useMemo(
    () => (activeFase ? activeCycleObj?.steps[getIndexByValue(activeCycleObj?.steps, activeFase)] : null),
    [activeCicle, activeCycleObj, activeFase],
  );

  const EmptyResult = () => {
    return (
      <>
        <div className="space-y-2 flex justify-center">
          <p className="text-white font-bold text-center text-2xl">Não há registros</p>
        </div>
      </>
    );
  };

  return (
    <>
      <div className="mx-auto container p-3 lg:p-10 ">
        <>
          <div className=" mb-3 lg:mb-10">
            <div className="flex flex-ro items-center space-x-3 lg:space-x-1">
              <div className="cursor-pointer" onClick={() => onClose()}>
                <button className="rounded-full bg-purple flex justify-center items-center p-1">
                  <RiArrowLeftSLine size={28} className="text-white" />
                </button>
              </div>

              <h1 className="text-lg lg:text-3xl  py-1 px-6 rounded-full">Realizações Destaques</h1>
            </div>
          </div>

          <div className="">
            <div className=" mb-3 lg:mb-10">
              <div className="flex flex-ro items-center space-x-3 lg:space-x-1">
                <h1 className="text-lg lg:text-2xl rounded-full">
                  Realizações Destaques <span className="text-yellow">({total || 0})</span> |{' '}
                  <span className="text-yellow">{optionsCycle[getIndexByValue(optionsCycle, activeCicle)]?.label}</span>
                </h1>
              </div>
            </div>

            <div className="mb-5 lg:flex items-center justify-end space-x-5">
              {optionsCycle && (
                <div className="w-full mb-3 lg:mb-0 ">
                  <CustomSelect
                    placeholder="Clique para selecionar o ciclo"
                    options={optionsCycle}
                    value={activeCycleObj}
                    onChange={(e: any) => {
                      setActiveCicle(e.value);
                      setActiveFase(null);
                    }}
                  />
                </div>
              )}

              {optionsCycle && (
                <div className="w-full mb-3 lg:mb-0 ">
                  <CustomSelect
                    placeholder="Selecione a Fase"
                    options={activeCycleObj?.steps}
                    value={activeFaseObj}
                    onChange={(e: any) => setActiveFase(e.value)}
                  />
                </div>
              )}
              <div className="w-full mb-3 lg:mb-0 ">
                <CustomSelect
                  placeholder="Selecione a quantidade de pontos"
                  options={options}
                  onChange={(e: any) => setPontos(e.value)}
                />
              </div>

              <div className="flex flex-row items-center space-x-4">
                <form onSubmit={e => loadData(0, e)} className="pl-1 -ml-1 flex-1 flex space-x-5">
                  <ReactInputMask
                    placeholder="Pesquise com unidade ou prefixo"
                    alwaysShowMask={false}
                    mask={mask}
                    ref={(ref: any) => {
                      searchRef.current = ref;
                    }}
                    inputMode="search"
                    style={{ fontSize: 16 }}
                    className="min-w-full lg:min-w-[416px] bg-maastricht-blue text-sm text-white font-thin flex-1 rounded-md py-2 px-4"
                  />
                </form>

                <TbSearch size={28} className="cursor-pointer hover:ring-2 mr-1 rounded-full" onClick={() => loadData()} />
              </div>
            </div>

            {load && (
              <div className="space-y-2">
                <ArticlePlaceholder />
                <ArticlePlaceholder />
              </div>
            )}

            <div className="flex flex-row items-center space-x-4">
              {!load && missionList && missionList.length > 0 ? (
                <div className="space-y-8 w-full">
                  {missionList?.map((item: any) => (
                    <RedePoint key={item._id} data={{ ...item, totalMissao: item.total, type: 'entrega_unidade' }} />
                    // <PointItem key={item._id} data={{ ...item, type: 'entrega_equipe_public' }} />
                  ))}
                </div>
              ) : null}
              {!load && missionList?.length === 0 && <EmptyResult />}
            </div>

            <div className={`mt-10 justify-center ${page < 2 ? 'hidden' : 'lg:flex '}`}>
              <ReactPaginate
                activeClassName={'item active '}
                breakClassName={'item break-me '}
                breakLabel={'...'}
                containerClassName={'pagination'}
                disabledClassName={'disabled-page'}
                nextClassName={'item next '}
                pageClassName={'item pagination-page '}
                previousClassName={'item previous'}
                initialPage={0}
                forcePage={activePag}
                nextLabel={<IoIosArrowForward style={{ fontSize: 18, width: 150 }} />}
                onPageChange={data => loadData(data.selected)}
                pageRangeDisplayed={3}
                pageCount={page}
                previousLabel={<IoIosArrowBack style={{ fontSize: 18, width: 150 }} />}
              />
            </div>
          </div>
        </>
      </div>
    </>
  );
}
